﻿
import utils from "./units";
import * as common from "./common";
import moment from "moment";

export function host(url) {

    const host = url.replace(/^https?:\/\//, "").replace(/\/.*$/, "");

    const parts = host.split(".").slice(-3);

    if (parts[0] === "www") {
        parts.shift();
    }

    return parts.join(".");
}

export function fromNow(value) {
    if (common.isEmpty(value)) {
        return "";
    }

    const date = moment(value);

    return date.fromNow();
}

export function formatDateTime(value) {
    if (value) {
        return moment(String(value)).format("MM/DD/YYYY hh:mm a");
    }
    return value;
}

export function formatDateOnly(value) {
    if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
    }
    return value;
}

export function formatTimeOnly(value) {
    if (value) {
        return moment(String(value)).format("hh:mm a");
    }
    return value;
}

export function timeAgo(time) {
    const between = Date.now() / 1000 - Number(time);

    if (between < 3600) {
        return pluralize(~~(between / 60), " minute");
    } else if (between < 86400) {
        return pluralize(~~(between / 3600), " hour");
    } else {
        return pluralize(~~(between / 86400), " day");
    }
}

export function toMinsDays(mins) {
    if (mins <= 60) {
        return pluralize(mins, " min");
    } else if (mins <= 1440) {
        return pluralize(~~(mins / 60), " hr");
    } else {
        return pluralize(~~(mins / 1440), " day");
    }
}

export function pluralize(time, label) {

    if (time === 1) {
        return time + label;
    }

    return time + label + "s";
}

export function float(value, precision) {
    if (typeof precision == "undefined") {
        precision = 1;
    }

    if (!value || isNaN(value)) {
        return value;
    } else if (typeof value == "string") {
        value = parseFloat(value);
    }

    return value.toFixed(precision);
}

export function percent(value, decimals) {

    if (typeof decimals == "undefined") {
        decimals = 0;
    }

    return common.round(value * 100, decimals) + "%";
}

export function formatTime(value) {
    //use: 'Boil' | 'Dry Hop' | 'Mash' | 'First Wort' | 'Aroma',
    return moment.duration(value, "minutes").humanize();
}

export function formatSGForDisplay(val, showPlato) {

    if (typeof showPlato == "undefined") {
        showPlato = false;
    }

    if (val == null || val === 0) {
        return 0.000 + " SG";
    }

    if (showPlato) {
        return ((-1 * 616.868) + (1111.14 * val) - (630.272 * Math.pow(val, 2)) + (135.997 * Math.pow(val, 3))).toFixed(2) + " °P";
    }

    return val.toFixed(3) + " SG";
}

export function hopUsage(value) {
    switch (value) {
        case 10:
            return "First Wort";
        case 20:
            return "Mash";
        case 30:
            return "Boil";
        case 40:
            return "Whirlpool";
        case 50:
            return "Dry Hop";
        default:
            return "Boil";
    }
}

export function hopForm(value) {
    switch (value) {
        case 10:
            return "Pellet";
        case 20:
            return "Plug";
        case 30:
            return "Hop Shot";
        default:
            return "Pellet";
    }
}

export function yeastType(value) {
    switch (value) {
        case 10:
            return "Liquid";
        case 20:
            return "Dry";
        case 30:
            return "Slant";
        case 40:
            return "Culture";
        default:
            return "Liquid";
    }
}

export function yeastForm(value) {

    switch (value) {
        case 10:
            return "Ale";
        case 20:
            return "Lager";
        case 30:
            return "Wheat";
        case 40:
            return "Wine";
        case 50:
            return "Champagne";
        default:
            return "Ale";
    }
}

export function miscType(value) {

    console.log('miscType', value);

    switch (value) {
        case 10:
            return "Spice";
        case 20:
            return "Fining";
        case 30:
            return "Water Agent";
        case 40:
            return "Herb";
        case 50:
            return "Flavor";
        case 60:
            return "Other";
        default:
            return "Other";
    }
}

export function miscUsage(value) {

    console.log('miscUsage', value);

    switch (value) {
        case 10:
            return "Mash";
        case 20:
            return "Boil";
        case 30:
            return "Primary";
        case 40:
            return "Secondary";
        case 50:
            return "Bottle";
        default:
            return "Boil";
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/filters.js
// module id = 76
// module chunks = 6 7 8